module.exports = __webpack_public_path__ + "img/mouse pad.2005833e.svg";